export default __webpack_public_path__ + "a3c8219ff02ce62c12d98c3b1c7c0fea.png";